import * as AbWorkflow from '../util/workflow'

export const getTempDocumentUrl = (tableName, keys, docField) => {
  return AbWorkflow.callMethod(
    'AbCommonResources-DocumentManager-getDocumentUrl',
    [tableName, keys, docField]
  )
    .then(({code, message}) => {
      let url = null
      if (code === 'executed') {
        url = message
      }
      return Promise.resolve(url)
    })
    .catch(message => {
      return Promise.reject(message)
    })
}
